import React from "react";

/**
 * Tesseract (4D hypercube) icon drawn in the lucide-react visual style:
 * 24x24 grid, currentColor stroke, round joins. A nested cube-in-cube
 * projection with the four connecting edges — reads as a "tesseract".
 *
 * Accepts the same sizing pattern as lucide icons (className="h-4 w-4").
 */
export const TesseractIcon = React.forwardRef(
  ({ size = 24, strokeWidth = 2, className = "", ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <rect x="3" y="3" width="18" height="18" rx="1" />
      <rect x="8" y="8" width="8" height="8" rx="0.5" />
      <line x1="3" y1="3" x2="8" y2="8" />
      <line x1="21" y1="3" x2="16" y2="8" />
      <line x1="3" y1="21" x2="8" y2="16" />
      <line x1="21" y1="21" x2="16" y2="16" />
    </svg>
  )
);

TesseractIcon.displayName = "TesseractIcon";

export default TesseractIcon;
